import GetCare from './GetCare.component';
import GetCarePage from './GetCare.page';

export default GetCarePage;

export { GetCare };
export type { ITopic, ITopicCard } from './GetCare.data';
